import { SET_USER_PREFERENCE } from './types';
import axios from 'axios';

const baseUrl = `/api/v1/user-preferences`;

const setUserPreference = (payload) => ({ type: SET_USER_PREFERENCE, payload });

const createUserPreferences = async () => {
  try {
    await axios.post(baseUrl);
  } catch (error) {
    console.error(error);
  }
};

export const fetchUserPreferences = () => async (dispatch) => {
  try {
    const response = await axios.get(baseUrl);
    await dispatch(setUserPreference(response.data));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      await createUserPreferences();
    } else {
      throw error;
    }
  }
};

export const updateUserPreferences = (userPreference) => async () => {
  try {
    await axios.patch(baseUrl, userPreference);
  } catch (error) {
    if (error.response && error.response.status === 404) {
      // eslint-disable-next-line no-console
      console.error('cannot patch user preferences: not found.');
    } else {
      throw error;
    }
  }
};
